import { createBrowserRouter } from "react-router";
import { SessionProvider } from "~/ory";
import { CompleteDeleteAccount } from "~/pages/Account/CompleteDeleteAccount";
import { DeleteAccount } from "~/pages/Account/DeleteAccount";
import {
	ActivateSendEmail,
	ActivateSentEmail,
	ActivateSetPassword,
} from "~/pages/Activate";
import { ErrorPage } from "~/pages/Error";
import { Home } from "~/pages/Home";
import { Login } from "~/pages/Login";
import { ConsentPage } from "~/pages/Oidc/Consent";
import { OidcError } from "~/pages/Oidc/Error";
import { Recovery } from "~/pages/Recovery";
import { Registration, RegistrationComplete } from "~/pages/Registration";
import { Settings } from "~/pages/Settings";
import { Terms } from "~/pages/Terms";
import { Verify, VerifyComplete } from "~/pages/Veirfy";

export const router = createBrowserRouter([
	{
		path: "/",
		element: (
			<SessionProvider>
				<Home />
			</SessionProvider>
		),
	},
	{
		path: "/login",
		element: <Login />,
	},
	{
		path: "/registration",
		element: <Registration />,
	},
	{
		path: "/complete-registration",
		element: (
			<SessionProvider>
				<RegistrationComplete />
			</SessionProvider>
		),
	},
	{
		path: "/recovery",
		element: <Recovery />,
	},
	{
		path: "/activate",
		element: <ActivateSendEmail />,
	},
	{
		path: "/activate/sent-email",
		element: <ActivateSentEmail />,
	},
	{
		path: "/activate/set-password",
		element: (
			<SessionProvider>
				<ActivateSetPassword />
			</SessionProvider>
		),
	},
	{
		path: "/verify",
		element: (
			<SessionProvider>
				<Verify />
			</SessionProvider>
		),
	},
	{
		path: "/complete-verification",
		element: <VerifyComplete />,
	},
	{
		path: "/settings",
		element: (
			<SessionProvider>
				<Settings />
			</SessionProvider>
		),
	},
	{
		path: "/account/delete",
		element: (
			<SessionProvider>
				<DeleteAccount />
			</SessionProvider>
		),
	},
	{
		path: "/account/complete-delete",
		element: <CompleteDeleteAccount />,
	},
	{
		path: "/consent",
		element: (
			<SessionProvider>
				<ConsentPage />
			</SessionProvider>
		),
	},
	{
		path: "/oidc/error",
		element: <OidcError />,
	},
	{
		path: "/terms",
		element: <Terms />,
	},
	{
		path: "/error",
		element: <ErrorPage />,
	},
]);
